/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const YandexIconConfig = {
  name: 'YandexIcon',
  height: 512,
  width: 256,
  svgPath: 'M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(YandexIconConfig);
//# sourceMappingURL=yandex-icon.js.map